module.exports = __webpack_public_path__ + "img/music-work-icon10.31827cb4.png";